import script from "./ViewTemplateAdvance.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTemplateAdvance.vue?vue&type=script&setup=true&lang=js"

import "./ViewTemplateAdvance.vue?vue&type=style&index=0&id=5e09d30e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e09d30e"]])

export default __exports__